module.exports = __webpack_public_path__ + "static/media/KMH_5051.368b38de.jpg";